export default __webpack_public_path__ + "static/media/offline_online.51e9e118.png";